import { isArray } from 'lodash-es';

export const bodyToSanitizedBody = (body: unknown): unknown => {
    switch (true) {
        case body === '':
            return undefined;
        case typeof body === 'string':
            return body;
        case body === null:
            return body;
        case typeof body === 'number':
            return body;
        case isArray(body):
            return objectToSanitizedObject(body);
        case body?.constructor.name === 'Object':
            return objectToSanitizedObject(body);
        default:
            return body;
    }
};

export const objectToSanitizedObject = (object: unknown): unknown => {
    const stringBody = JSON.stringify(object, (_key, value): unknown =>
        value === null || value === '' ? undefined : value,
    ) as string | undefined;

    return stringBody === undefined
        ? undefined
        : (JSON.parse(stringBody) as unknown);
};
